import React from 'react';
import clsx from 'clsx';
import { hashClass } from '../../../../helpers';
import { useTrilogyContext } from '../../../../context';
/**
 * ListItem Component
 * @param className {string} Additionnal CSS Classes
 * @param children {React.ReactNode}
 */
const ListItemDescription = ({ children, className }) => {
    const { styled } = useTrilogyContext();
    return React.createElement("dd", { className: hashClass(styled, clsx(className)) }, children);
};
export default ListItemDescription;
//# sourceMappingURL=ListItemDescription.js.map